import OrderCargoOrderDetailsHandlingLogRequest, {
  OrderCargoOrderDetailsHandlingLogRequestQueryParams,
} from "./order-cargo-order-details-handling-log.request";

const createQueryParams = (
  data: OrderCargoOrderDetailsHandlingLogRequest,
): OrderCargoOrderDetailsHandlingLogRequestQueryParams => {
  return {
    creationStart: data.creationStart || null,
    creationEnd: data.creationEnd || null,
  };
};

const orderCargoOrderDetailsHandlingLogRequestFactory = {
  createQueryParams,
};

export default orderCargoOrderDetailsHandlingLogRequestFactory;
